import { MobileDetection, APIRequest } from '@reverbdotcom/discovery-ui';
import { UI } from './legacy/ui';

function trackProductView() {
  const trackViewPath = $('[data-track-view-path]').data('track-view-path');

  if (trackViewPath) {
    APIRequest.post(trackViewPath);
  }
}

function bindWatchUnwatch() {
  if (!UI.isLoggedIn()) { return; }

  const watchLink = '[data-bind=\'watch-link\']';
  const unwatchLink = '[data-bind=\'unwatch-link\']';
  const response = '[data-bind=\'watchlist-response\']';

  const displayResponse = function ($clicked) {
    $clicked.toggleClass('hide');
    $clicked.siblings(watchLink).toggleClass('hide');
    $clicked.siblings(unwatchLink).toggleClass('hide');
    $clicked.siblings(response).stop().slideDown('fast').delay(3000)
      .slideUp('fast');
  };

  $(document).on('click', watchLink, function () {
    const $clicked = $(this);
    const watchlistLink = $(watchLink).data('watchlist-link');
    $clicked.siblings(response).html(I18n.t(
      'js.watchList.itemAdded',
      { link_open: `<a href="${watchlistLink}">`, link_close: '</a>' },
    ));
    displayResponse($clicked);
  });

  $(document).on('click', unwatchLink, function () {
    const $clicked = $(this);
    $clicked.siblings(response).html(I18n.t('js.watchList.itemRemoved'));
    displayResponse($clicked);
  });
}

function bindInlineOfferButtonToPopup() {
  // Mobile browsers fall through to a regular html request for the lightbox
  if (MobileDetection.isMobileBrowser()) { return; }

  const inline_offer_form = $('form#inline_offer');
  const make_offer_button = $('#make_offer_button');
  const inline_price = $('#inline_offer_price');

  make_offer_button.on('click', function (e) {
    e.preventDefault();
    if (!UI.isLoggedIn()) { return; }

    if (inline_price.val()) {
      UI.Ajax.lightbox(`${$(this).prop('href')}?price=${inline_price.val()}`);
    }
  });

  inline_offer_form.submit((e) => {
    e.preventDefault();
    make_offer_button.click();
  });
}

function init() {
  bindInlineOfferButtonToPopup();
  bindWatchUnwatch();
  trackProductView();
}

$(init);

export default {
  init,
};
